"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableSettingDialog = void 0;
const Form_1 = require("@juvare/common-form-ui/Form");
const DialogHelper_1 = require("@juvare/common-web-ui/DialogHelper");
const utils_1 = require("@juvare/common-web-ui/utils");
const shared_1 = require("../../../../backend/features/editable-settings/shared");
const hooks_1 = require("../../../../ui/hooks");
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const swr_1 = __importDefault(require("swr"));
const buildSettingEditForm_1 = require("../utils/buildSettingEditForm");
const EditableSettingDialog = ({ name, onClose }) => {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const storageClient = (0, hooks_1.useStorageClient)(shared_1.settingEntityName);
    const { data, isLoading, isValidating, error } = (0, swr_1.default)([`/platform/storage/setting/getByName`, name], (_a) => __awaiter(void 0, [_a], void 0, function* ([, name]) {
        const listResponse = yield storageClient.list({ filter: [{ column: 'name', op: '=', value: name }] });
        if (listResponse.total > 0) {
            return storageClient.get(listResponse.rows[0].id);
        }
        else {
            throw new Error(`Setting ${name} does not exist`);
        }
    }), {
        revalidateOnFocus: false,
    });
    const readOnly = (data === null || data === void 0 ? void 0 : data.data.readOnly) || false;
    const [closing, setClosing] = react_1.default.useState();
    const formRef = react_1.default.useRef(null);
    const settingForm = react_1.default.useMemo(() => (data && !isLoading && !isValidating ? (0, buildSettingEditForm_1.buildSettingEditForm)(data) : undefined), [data, isLoading, isValidating]);
    const [formResetKey, setFormResetKey] = react_1.default.useState(0);
    return (react_1.default.createElement(material_1.Dialog, { fullWidth: true, open: (settingForm || error != null) && !closing, TransitionProps: {
            onExited: () => {
                if (closing) {
                    onClose(!!(closing === null || closing === void 0 ? void 0 : closing.changed));
                }
            },
        } },
        data && settingForm && react_1.default.createElement(material_1.DialogTitle, null, data.data.description),
        react_1.default.createElement(material_1.DialogContent, null,
            data && settingForm && error == null && (react_1.default.createElement(material_1.Box, { mt: 1 },
                react_1.default.createElement(Form_1.Form, { key: formResetKey, ref: formRef, config: settingForm.formConfig, data: formResetKey === 0 ? settingForm.formData : settingForm.defaultFormData, hideFormControls: true, onSubmit: (newData) => storageClient.post({
                        action: 'partial-update',
                        id: data.id,
                        data: { value: settingForm.mapResult(newData) },
                    }), onSubmitSuccess: () => setClosing({ changed: true }), readOnly: readOnly }))),
            !isLoading && !isValidating && error != null && react_1.default.createElement(material_1.Alert, { severity: 'error' }, (0, utils_1.getErrorMessage)(error))),
        data && settingForm && error == null && (react_1.default.createElement(material_1.DialogActions, null,
            react_1.default.createElement(material_1.Button, { onClick: () => (0, DialogHelper_1.showAlertDialog)({
                    title: t('editableSettings.settingDetails'),
                    content: (react_1.default.createElement("pre", { style: { margin: 0 } }, JSON.stringify(data
                        ? {
                            name: data.data.name,
                            description: data.data.description,
                            group: data.data.group,
                            public: !!data.data.public,
                            type: data.data.type,
                            value: (0, shared_1.mapSettingValueFromRow)(data),
                            defaultValue: data.data.defaultValue,
                        }
                        : null, undefined, '  '))),
                }) }, t('editableSettings.showDetails')),
            (data === null || data === void 0 ? void 0 : data.columns.changed) && !readOnly && (react_1.default.createElement(material_1.Button, { onClick: () => setFormResetKey((key) => key + 1) }, t('editableSettings.resetToDefault'))),
            react_1.default.createElement("div", { style: { flex: '1 0 0' } }),
            !readOnly && react_1.default.createElement(material_1.Button, { onClick: () => setClosing({ changed: false }) }, t('common.cancel')),
            !readOnly && react_1.default.createElement(material_1.Button, { onClick: () => { var _a; return (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.submit().catch(() => { }); } }, t('common.save')))),
        ((!isLoading && !isValidating && error != null) || readOnly) && (react_1.default.createElement(material_1.DialogActions, null,
            react_1.default.createElement(material_1.Button, { onClick: () => setClosing({ changed: false }) }, t('common.ok'))))));
};
exports.EditableSettingDialog = EditableSettingDialog;
